import { MAIN_ROUTES } from './../../routing/constants/mainRoutes';
import { MessagesService } from '@base/features/chat/messagesService';
import { container } from 'tsyringe';
import React, { useEffect, useState } from 'react';
import { Message } from '../message';
import { useBehaviorSubject, useSubject } from '@base/utils/helpers';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import UserService from '@base/features/user/model/userService';
import { useHistory } from 'react-router-dom';

type usePrivateChatType = {
  myMessage: string;
  setMyMessage: (e: React.ChangeEvent<HTMLInputElement>) => void;
  sendMessage: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, pid: number) => void;
  messages: Message[] | undefined;
  handleEmoji(emoji: string): void;
};

export const usePrivateChat = (): usePrivateChatType => {
  const messagesService: MessagesService = container.resolve('messagesService');
  const userService: UserService = container.resolve('userService');
  const history = useHistory();
  const [myMessage, setMyMessage] = useState('');
  const recipient = useBehaviorSubject(messagesService.onPrivateChatJoined);
  const [messages, setMessages] = useState<Message[]>();

  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const changed = useSubject(playersOnlineRepository.onInOutPlayer);

  useEffect(() => {
    if (!recipient) return;
    const messages = recipient.getChatMessages();
    setMessages(messages);
  }, [recipient, changed]);

  function handleMessage(e: React.ChangeEvent<HTMLInputElement>): void {
    setMyMessage(e.target.value);
  }

  function sendMessage(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, pid: number) {
    e.preventDefault();
    if (!myMessage.length) return;
    if (userService.isGuestPlayer())
      return userService.openGuestModal(() => history.push(MAIN_ROUTES.register));
    messagesService.sendMessagePrivate(myMessage, -1, pid);
    setMyMessage('');
  }

  function handleEmoji(emoji: string) {
    setMyMessage((prevState) => `${prevState} ${emoji} `);
  }

  return {
    myMessage,
    setMyMessage: handleMessage,
    sendMessage,
    messages,
    handleEmoji,
  };
};
